import { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash/fp';
import { Button, ButtonVariant, ButtonSize } from 'app/components/core/Button';
import * as styles from './UploadButton.css';

export function UploadButton({
    name,
    label = 'Upload',
    accept = '.csv, .tsv, text/csv',
    onUpload = noop,
    multiple = false,
    ...props
}) {
    const inputRef = useRef();

    function handleClick() {
        inputRef.current.click();
    }

    function handleUpload(event) {
        onUpload([...event.nativeEvent.target.files]);
        inputRef.current.value = null;
    }

    return (
        <Fragment>
            <input
                autoComplete="off"
                name={name}
                type="file"
                className={styles.fileUpload}
                ref={inputRef}
                onChange={handleUpload}
                accept={accept}
                multiple={multiple}
            />
            <Button
                icon="document"
                variant={ButtonVariant.PRIMARY}
                onClick={handleClick}
                {...props}>
                {label}
            </Button>
        </Fragment>
    );
}

UploadButton.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    accept: PropTypes.string,
    onUpload: PropTypes.func,
    size: PropTypes.oneOf(Object.values(ButtonSize)),
    multiple: PropTypes.bool
};
